export { default } from './Rating';
